import store from "../store";
import axios from "axios";

export default {
    loadMetaData(){
        if(Object.keys(WEBSITE_META_DATA).length !== 0){
            axios
            .get(`${WEBSITE_META_DATA}`)
            .then((response) => {
                store.commit(
                    "meta/setMetaData",
                    response.data
                );
                return 
            })
            .catch((error) => {
                console.log(`${error} [website meta data] response failed`);
            });
        }
        
    },
}
